module.exports = __webpack_public_path__ + "img/20200514_151526.5244daf2.jpg";